import "./EventCard.css";

const EventCard = ({ imgSrc, spanTag, name, mapRespawn, color, reward, coordStart, description}) => {
  return (
    <div className="card">
      <div className="card__inner">
        
        {/* Frente */}
        <div className="card__front">
          <div className="card__header">
            <h2 className="card-title">{name}</h2>
          </div>
          <div className="card__body">
            <img src={imgSrc} alt={name} />
            <span style={{ color: color }} className="card__body__date">
              {spanTag}
            </span>
          </div>
          <div style={{ backgroundColor: color }} className="card__footer">
            <div className="card__Footer__second">
              <p>{mapRespawn}</p> 
            </div>
          </div>
        </div>

        {/* Dorso */}
        <div className="card__back" style={{ backgroundColor: color }}>
          <div className="card__back__content">
            <p>{description}</p>
            <h4 style={{ color: "white" }}>Recompensa: </h4>
            {reward.map((reward)=>(
                <p>{reward}</p>
            ))}

            {coordStart && <h4 style={{ color: "white" }}>Coordenada: {coordStart}</h4>}

          </div>
        </div>

      </div>
    </div>
  );
};

export default EventCard;